export const site = {
  brand: "网爆吃瓜",
  slogan: "边吃瓜边玩梗，快乐加倍",
  description:
    "网爆吃瓜是吃瓜娱乐二创聚集地，网爆吃瓜表情包、段子、神回复和梗图持续上新，网爆吃瓜群众评论与二创视频都在这里，边吃瓜边玩梗。",
  email: "hi@wangbaochigua.com",
  updateTime: "每日 08:00 / 14:00 / 21:00 三次上新",
};

export const navItems = [
  { label: "首页", path: "/" },
  { label: "表情包", path: "/biaoqingbao" },
  { label: "段子", path: "/duanzi" },
  { label: "神回复", path: "/shenhuifu" },
  { label: "梗图", path: "/gengtu" },
  { label: "二创视频", path: "/shipin" },
  { label: "关于我们", path: "/about" },
];

export const stats = [
  { label: "在库表情包", value: "1280+" },
  { label: "段子与梗图", value: "960+" },
  { label: "群众神回复", value: "3400+" },
  { label: "日均上新", value: "120 条" },
];

export const marqueeLines = [
  "今日热梗：周一综合征已上线",
  "神回复正在赶来的路上",
  "梗图屯图党请注意流量",
  "评论区比正文更好笑",
  "表情包已更新，请自取",
  "边吃瓜边玩梗，快乐加倍",
];